/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./styles";
import { NEW_ENTRY_FIELDS, LABELS } from "../../contants/formFields";
// import InputField from "../common/InputField/InputField";
import InputField from "../common/new/InputField/InputField";
import Button from "../common/Button";

function AssignRequestForm({
  handleChange,
  values,
  handleSubmit,
  city,
  state,
  setFieldValue,
}) {
  useEffect(() => {
    if (city) {
      setFieldValue(NEW_ENTRY_FIELDS.CITY, city);
    }
    if (state) {
      setFieldValue(NEW_ENTRY_FIELDS.STATE, state);
    }
  }, [city, state]);
  return (
    <Box sx={{ width: "60%", py: 20, px: "1rem" }}>
      <Grid container spacing={2}>
        <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            required
            label={LABELS.ADDRESS_LINE_1}
            name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
            onChange={handleChange}
            style={styles.customTextFieldSecondary}
            value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
          />
        </Grid>
        {/* <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            label={LABELS.ADDRESS_LINE_2}
            name={NEW_ENTRY_FIELDS.ADDRESS_LINE_2}
            onChange={handleChange}
            style={styles.customTextFieldSecondaryTwo}
            value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
          />
        </Grid> */}
        <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            required
            optionLabelId="cityName"
            options={[]}
            label={LABELS.CITY}
            name={NEW_ENTRY_FIELDS.CITY}
            onChange={handleChange}
            style={styles.customTextFieldSecondary}
            value={values[NEW_ENTRY_FIELDS.CITY]}
            disabled
          />
        </Grid>
        <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            required
            label={LABELS.STATE}
            style={styles.customTextFieldSecondaryTwo}
            name={NEW_ENTRY_FIELDS.STATE}
            onChange={handleChange}
            value={values[NEW_ENTRY_FIELDS.STATE]}
            disabled
          />
        </Grid>
        <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            label={LABELS.PINCODE}
            style={styles.customTextFieldSecondary}
            name={NEW_ENTRY_FIELDS.PINCODE}
            onChange={handleChange}
            value={values[NEW_ENTRY_FIELDS.PINCODE]}
            inputProps={{
              maxLength: 6,
            }}
          />
        </Grid>
        <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            required
            label={LABELS.CONTACT_NUMBER}
            style={styles.customTextFieldSecondaryTwo}
            name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
            onChange={handleChange}
            value={values[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
            inputProps={{
              maxLength: 10,
            }}
          />
          {/* <InputField
              label={LABELS.DOB}
              name={NEW_ENTRY_FIELDS.DATE_OF_JOINING}
              onChange={handleChange}
              style={styles.customTextFieldSecondaryTwo}
              value={values[NEW_ENTRY_FIELDS.DATE_OF_JOINING]}
            /> */}
        </Grid>
        {/* <Grid item md={6} sm={12} style={styles.gridPrimary}>
          
        </Grid> */}
        <Grid item md={6} sm={12} style={styles.gridPrimary}>
          <InputField
            // required
            label={LABELS.EMAIL_ADDRESS}
            style={styles.customTextFieldSecondary}
            name={NEW_ENTRY_FIELDS.EMAIL_ADDRESS}
            onChange={handleChange}
            value={values[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
          />
        </Grid>
        <Box
          mt={4}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            label="Assign To"
            onClick={() => {
              handleSubmit();
            }}
          />
        </Box>
      </Grid>
    </Box>
  );
}

export default AssignRequestForm;
